
import Vue from 'vue';
import Component from 'vue-class-component';

@Component({})

export default class AppEnabledMsg extends Vue {
    private shopifyTabOpened = false;

    mounted() {
        const self = this;
        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'visible' && self.shopifyTabOpened) {
                location.reload();
            }
        });
    }

    get appExtensionLink(): string {
        return this.$isShopify ? `https://admin.shopify.com/store/${this.$store.state.shopStats.domain.replace('.myshopify.com', '')}/themes/${this.$store.state.shopStats.themeId}/editor?context=apps` : '';
    }

    redirectToTheme() {
        window.open(this.appExtensionLink, '_blank');
        this.shopifyTabOpened = true;
    }

    appEmbedEnabled() {
        return this.$store.state.shopStats.appEnabled;
    }
}
